<template>
  <div>
    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="{order_id:this.id}"
               :showSearchForm="false"
               tableApi="admin/settlement/getOrderSettleDetail"
    >

    </pageTable>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  export default {
    name: "edit",
    components:{pageTable},
    props:{
      id:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        tableColumn: [
          {title: 'ID',key: 'id'},
          {title: '结算金额',key: 'amount'},
          {title: '备注',key: 'remark'},
          {title: '凭证',key: 'proof',render:(h,params)=>{
            if (params.row.proof===''){
              return h('span','无凭证')
            }
            let content = [];
              params.row.proof.forEach(item=>{
                content.push(h('img',{
                  attrs:{src:item},
                  style:{width:'40px',height:'40px'
                  },
                  on:{click:()=>{
                      this.$Modal.info({
                        // title: title,
                        width:800,
                        footerHide:true,
                        content: `<img src="${item}" style="max-width: 500px;max-height: 500px">`
                      });
                    }}
                }))
              })
              return h('div',content)
            }},
          {title: '打款日期',key: 'pay_day',width:150},
          {title: '上传日期',key: 'create_time',width:170},
        ],
      }
    },
    methods:{

    },
    mounted() {

    },
    watch:{

    }
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

</style>
